export default "__VITE_ASSET__CqIsx2CE__"